import React, { forwardRef, useEffect, useState } from "react";
import { tns } from "tiny-slider/dist/tiny-slider";

/**
 * @param {{children: ReactNode, options: import("tiny-slider/dist/tiny-slider").TinySliderSettings, slider?: import("tiny-slider/dist/tiny-slider").TinySliderInstance || null, setSlider?: (slider: import("tiny-slider/dist/tiny-slider").TinySliderInstance) => void}} props
 */

const TinySlider = ({ children, options = {}, slider, setSlider }, ref) => {
  const [innerSlider, setInnerSlider] = useState(null);

  useEffect(() => {
    if (setSlider && slider !== undefined) {
      if (!slider) {
        setSlider(tns(options));
      }
    } else if (!innerSlider) {
      setInnerSlider(tns(options));
    }

    return () => {
      innerSlider?.destroy?.();
    };
  }, [setSlider, slider, innerSlider, options]);

  return (
    <div ref={ref} className={`${options.container?.split(".")[1]} position-relative`}>
      {children}
    </div>
  );
};


export default forwardRef(TinySlider);
